import React from "react";
import styled from "styled-components";

const Disclaimer = styled.p<{ altTheme: boolean }>`
    background: var(--primary);
    color: var(--page-bg);
    line-height: 1.2;
    margin-bottom: 2rem;
    padding: 1rem;
    padding-left: 3.5rem;
    position: relative;

    body.theme-market & {
        background: var(--page-bg);
        color: var(--text-primary);
        font-family: var(--ff-title);
        line-height: 1.5;
    }

    ${({ altTheme }) => altTheme && `
        background: var(--accent);
        body.theme-market &,
        body.theme-platinum & {
            background: var(--primary);
        }
    `}    
`;

const DisclaimerIcon = styled.span`
    font-size: 1.5rem;
    position: absolute;
    left: 1rem;
    top: 50%;
    transform: translateY(-50%);
`;

const NotAReceiptAlert = ({ altTheme = false }: { altTheme?: boolean }) => {
    return (
        <Disclaimer altTheme={altTheme}>
            <DisclaimerIcon className="fas fa-exclamation-circle" style={{ marginRight: '1rem' }}></DisclaimerIcon>
            Esta información <strong>NO</strong> es válida como boleto. Transacción pendiente de pago.
        </Disclaimer>
    );
};

export default NotAReceiptAlert;